import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setSubTitle,
  setWheelName,
} from "../../../../redux/reducers/segmentBuilder";
import TextView from "../../../TextView";
import { Container } from "../../CreateWheelPopup.styled";
import CustomInput from "../../../Input";
import styled from "styled-components";

const CharacterCounter = styled.div`
  text-align: right;
  font-size: 12px;
  color: ${(props) => (props.isMax ? "#FF4D4F" : "#888888")};
  margin-top: -20px;
  margin-bottom: 10px;
`;

function First({ error, clearError }) {
  const dispatch = useDispatch();

  const handleTitleChange = (val) => {
    dispatch(setWheelName(val)); // Dispatch action to update wheel name
    if (clearError) clearError(); // Clear error when user starts typing
  };

  const handleSubtitleChange = (val) => dispatch(setSubTitle(val));

  const wheelInformation = useSelector((state) => state.segmentBuilder);
  const subtitle =
    wheelInformation?.history[wheelInformation?.currentIndex]?.sub_title || "";
  const isMaxLength = subtitle.length >= 100;

  return (
    <Container>
      <TextView variant="title" style={{ textAlign: "center" }}>
        Give your Wheel a name!
      </TextView>

      <CustomInput
        label={
          <TextView variant="subtitle" style={{ marginTop: "24px" }}>
            Wheel Title
          </TextView>
        }
        variant={"secondary"}
        placeholder="Enter wheel name"
        onChange={(e) => handleTitleChange(e?.target?.value)}
        value={
          wheelInformation?.history[wheelInformation?.currentIndex]?.wheel_name
        }
        error={error ? "Wheel name is required" : ""}
      />

      <CustomInput
        variant={"secondary"}
        label={
          <TextView variant="subtitle">
            Subtitle <span style={{ color: "#BBBBBB" }}>(optional)</span>
          </TextView>
        }
        maxLength={100}
        placeholder="An explanatory one liner about your wheel!"
        onChange={(e) => handleSubtitleChange(e?.target?.value)}
        value={subtitle}
      />
      <CharacterCounter isMax={isMaxLength}>
        {subtitle.length}/100
      </CharacterCounter>
    </Container>
  );
}

export default First;
